module.exports = __webpack_public_path__ + "img/story-2mobile-en.5fe58c16.png";